<template lang="pug">
  ServiceListSelect(
      :locationId="locationId" 
      multiselect
      @input="onServicesSelect" 
      style="width: 100%"
      type="service")
</template>
<script>
import intersection from 'lodash/intersection'
import {mapGetters, mapState} from 'vuex'
import ServiceListSelect from '../services/ServiceListSelect'
export default {
  name: 'SlotFinderServiceSelector',
  components: {
    ServiceListSelect
  },
  props: {
    locationId: {type: String, required: true}
  },
  data() {
    return {
      locationStaff: [],
      locationResources: []
    }
  },
  computed: {
    ...mapState('services', ['servicesMap']),
    ...mapGetters('staff', ['activeServiceMembersByLocations']),
    ...mapGetters('resources', ['resourcesByLocation'])
  },
  created() {
    this.locationStaff = this.activeServiceMembersByLocations(this.locationId).map(s => s._id)
    this.locationResources = this.resourcesByLocation(this.locationId).map(s => s._id)
  },

  methods: {
    onServicesSelect(services) {
      let potentialResources, potentialStaff
      if (services.length) {
        let elems = services.map(s => this.servicesMap[s.serviceId].staff)
        elems.push(this.locationStaff)
        potentialStaff = intersection.apply(null, elems)

        potentialResources = intersection.apply(
          null,
          services.map(s => this.servicesMap[s.serviceId].resources || [])
        )
      } else {
        potentialStaff = [...this.locationStaff]
        potentialResources = []
      }
      this.$emit('input', {
        services: services.map(s => {
          let service = this.servicesMap[s.serviceId]
          let option = service.pricingOptions.find(p => p._id === s.optionId)
          return {service, option}
        }),
        staff: potentialStaff,
        resources: potentialResources
      })
    }
  }
}
</script>
